module.exports = __webpack_public_path__ + "img/emoji_87.cb9cbafa.png";